import React from 'react';
import { Popover } from '@milanote/roma';
import { InsertRightIcon } from '@milanote/roma-icons';
import InsertMenuToolbarContent from './InsertMenuToolbarContent';
import RomaToolbarIcon from '../../../roma/RomaToolbarIcon';
import useToolbarPopover from '../../../../hooks/useToolbarPopover';
import ToolbarTool from '../../../ToolbarTool';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { useOpenBoardLinkPopup } from '../../../../../../components/tiptapEditor/extensions/boardLinks/useOpenBoardLinkPopup';
import { useOpenEmojiPopup } from '../../../../../../components/tiptapEditor/extensions/emojis/useOpenEmojiPopup';
import { closeTiptapSelectionPopup } from '../../../../../../components/tiptapEditor/popup/tiptapSelectionPopupActions';
import { ToolbarItemConfig } from '../../../../toolbarTypes';
import { Button } from 'react-aria-components';
import { useDispatch } from 'react-redux';

type InsertMenuToolProps = {
    name?: string;
    element?: ImMNElement;
    item?: ToolbarItemConfig;
};

const InsertMenuTool: React.FC<InsertMenuToolProps> = ({ name = 'Insert', element, item, ...toolProps }) => {
    const dispatch = useDispatch();
    const { isOpen, onOpenChange } = useToolbarPopover();
    const openBoardLinkPopup = useOpenBoardLinkPopup();
    const openEmojiPopup = useOpenEmojiPopup();

    const handleInsertMenuOpenChange = (open: boolean) => {
        onOpenChange(open);

        if (!open) return;

        dispatch(closeTiptapSelectionPopup());
    };

    const dispatchClosePopup = () => onOpenChange(false);

    return (
        <div className="InsertMenu ToolbarPopupTool">
            <Popover.MenuTrigger isOpen={isOpen} onOpenChange={handleInsertMenuOpenChange}>
                <Button className="Button" aria-label={name}>
                    <ToolbarTool {...toolProps} name={name} isOpen={isOpen} tooltipEnabled={!isOpen}>
                        <RomaToolbarIcon icon={InsertRightIcon} iconClassName="size-5" />
                    </ToolbarTool>
                </Button>
                <Popover className="w-75" placement="end top" offset={4} crossOffset={9}>
                    <InsertMenuToolbarContent
                        closePopup={dispatchClosePopup}
                        size={'md'}
                        onEmoji={openEmojiPopup}
                        onLinkBoard={openBoardLinkPopup}
                        element={element}
                    />
                </Popover>
            </Popover.MenuTrigger>
        </div>
    );
};

export default InsertMenuTool;
